import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import LogoLetra from '../assets/Logo_letra.png';
import LogoSimple from '../assets/Logo_simple.png';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      // Detectar sección activa
      const sections = ['inicio', 'nosotros', 'soluciones', 'equipo', 'contacto'];
      const scrollPosition = window.scrollY + 100; // Offset para mejor detección
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    navigate(`/${sectionId}`);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false); // Close mobile menu when clicking a link
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src={LogoLetra} alt="TERA" />
        </div>
        
        {/* Desktop Menu */}
        <ul className="navbar-menu desktop-menu">
          <li 
            onClick={() => scrollToSection('inicio')}
            className={activeSection === 'inicio' ? 'active' : ''}
          >
            Inicio
          </li>
          <li 
            onClick={() => scrollToSection('nosotros')}
            className={activeSection === 'nosotros' ? 'active' : ''}
          >
            Nosotros
          </li>
          <li 
            onClick={() => scrollToSection('soluciones')}
            className={activeSection === 'soluciones' ? 'active' : ''}
          >
            Soluciones
          </li>
          <li 
            onClick={() => scrollToSection('equipo')}
            className={activeSection === 'equipo' ? 'active' : ''}
          >
            Nuestro Equipo
          </li>
          <li 
            onClick={() => scrollToSection('contacto')}
            className={activeSection === 'contacto' ? 'active' : ''}
          >
            Contacto
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        {/* Menú móvil a pantalla completa (mismo icono que la pestaña del navegador) */}
        <div
          className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}
          role="presentation"
          aria-hidden={!isMobileMenuOpen}
        >
          <img className="mobile-menu-favicon" src={LogoSimple} alt="TERA" />
          <ul className="navbar-menu mobile-menu-list">
            <li
              onClick={() => scrollToSection('inicio')}
              className={activeSection === 'inicio' ? 'active' : ''}
            >
              Inicio
            </li>
            <li
              onClick={() => scrollToSection('nosotros')}
              className={activeSection === 'nosotros' ? 'active' : ''}
            >
              Nosotros
            </li>
            <li
              onClick={() => scrollToSection('soluciones')}
              className={activeSection === 'soluciones' ? 'active' : ''}
            >
              Soluciones
            </li>
            <li
              onClick={() => scrollToSection('equipo')}
              className={activeSection === 'equipo' ? 'active' : ''}
            >
              Nuestro Equipo
            </li>
            <li
              onClick={() => scrollToSection('contacto')}
              className={activeSection === 'contacto' ? 'active' : ''}
            >
              Contacto
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;